<template>
  <el-button
    v-if="showed"
    v-loading.fullscreen.lock="fullScreenLoading"
    @click="pay"
    class="credit-card-button"
    :class="{
      'disabled-payment': disabled,
    }"
  >
    <img
      src="@/assets/img/icons/visa.png"
      width="33"
      height="22"
      alt="Visa"
    >
    <img
      src="@/assets/img/icons/mastercard.png"
      width="33"
      height="22"
      alt="Mastercard"
    >
  </el-button>
</template>

<script>
import paymentMixin from "../payment-mixin";

export default {
  name: "StripeCreditCard",
  mixins: [paymentMixin],
  props: {
    klarnaEnabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    sendLogs() {
      this.$amplitude.logEvent(
        "Payment page event Stripe Credit Card button clicked",
        {
          qrCode: this.qrCodes.join(","),
          amount: this.amount,
          currency: this.currency,
        }
      );
    },
    async pay() {
      this.fullScreenLoading = true;
      this.sendLogs()
      await this.$axios
        .post("/api/v1/session", {
          cancelUrl: `${
            process.env.VUE_APP_BASE_URL
          }/#/pay-confirm/${this.qrCodes.join(",")}/${this.currency}/${
            this.amount
          }`,
          successUrl: `${process.env.VUE_APP_BASE_URL}/#/receipt`,
          qrCodes: this.paymentObject,
          clientPaysFee: !!this.clientPaysFee,
          amount: this.amount,
          currency: this.currency,
          defaultPaymentType: this.klarnaEnabled ? "CreditCard" : null,
        })
        .then((response) => {
          if (response.data?.txId) {
            this.$cookie.delete("txId");
            this.$cookie.set("txId", response.data.txId);
            location.href = response.data.url;
          } else {
            this.$message.error(this.$t("form.something-wrong"));
            this.fullScreenLoading = false;
          }
        })
        .catch(() => {
          this.fullScreenLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.credit-card-button::v-deep {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 55px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #2c2e2f;
  border-radius: 4px;
  margin: 12px auto 0 auto;

  span {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      margin-right: 8px;
    }

    p {
      margin: 0;
      font-family: "Raleway SemiBold", serif;
      font-size: 24px;
    }
  }
}
</style>
